import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing, typography }: Theme) {
    // TODO: use styledBy to better allow for styling card background and text colors
    return {
        root: {
            height: '100%',
        },
    };
}